import { useEffect, useState, useRef } from "react";
import { Toast, Loading, Dialog } from "@xp-design/mobile";
import { useSearchParams } from "react-router-dom";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { winningRecord, getBenefitInfo } from "@/api/configPage.ts";
import NavBar from "@/components/navbar";
import "./index.less";
import {
  goToPage,
  getBrowserEnv,
  getChannel,
  getClientEnv,
} from "@/utils/tools";
import { goToNativePage, debounce, goToPageV2 } from "@/utils/common";
import img_empty from "@/assets/img_empty.png";
import { trackGdp } from "@/utils/gio-report";
import icon_close from "../configPage/assets/icon_close.png";
import PageContainer from "@/component/pageContainer";
import { useLockFn } from "ahooks";
import { processOssImage } from "@/utils/image";

// 中奖记录
const luckyRecord = () => {
  const [searchParams] = useSearchParams();
  const [recordList, setRecordList] = useState([]);
  console.log("recordList", recordList);
  const [copyDialogVisible, setCopyDialogVisible] = useState(false);
  const [copyDialogInfo, setCopyDialogInfo] = useState({
    productName: "",
    benefitType: 0,
    cardKey: "",
    cardNo: "",
    redeemLink: "",
    ruleDesc: "",
  });
  const [pageNo, setPageNo] = useState(1);
  const [pageSize] = useState(100); // 每页显示的记录数
  const [hasMore, setHasMore] = useState(true); // 是否还有更多数据
  const contentRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getList();
  }, [pageNo]);

  useEffect(() => {
    document.title = "奖品记录";

    // 添加滚动事件监听器
    const handleScroll = debounce(() => {
      const contentElement = contentRef.current;
      if (contentElement) {
        const scrollTop = contentElement.scrollTop;
        const scrollHeight = contentElement.scrollHeight;
        const clientHeight = contentElement.clientHeight;
        if (scrollTop + clientHeight >= scrollHeight - 100) {
          console.log("scroll to bottom");
          if (hasMore && !isLoading) {
            setPageNo((prevPageNo) => prevPageNo + 1);
          }
        }
      }
    }, 300);

    const contentElement = contentRef.current;
    if (contentElement) {
      contentElement.addEventListener("scroll", handleScroll);
    }
    // 清理事件监听器
    return () => {
      if (contentElement) {
        contentElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, [hasMore, isLoading]);

  // 获取中奖列表
  const getList = async () => {
    if (!hasMore) {
      return;
    }
    try {
      setIsLoading(true);
      Loading.show("加载中...");
      const res = await winningRecord({
        activityCode: searchParams.get("activityCode"),
        pageNo: pageNo,
        pageSize: pageSize,
      });
      if (res.code === 200) {
        console.log(res.data);
        const newArr = [...recordList, ...res.data.records];
        setRecordList(() => newArr);
        trackGdp("P20190", "B001", {
          trackName: "充电_营销奖品记录页_页面访问",
          origin: getChannel(),
          userType: "",
          activityId: searchParams.get("activityCode"),
        });
        // 检查是否还有更多数据
        setHasMore(res.data.total > newArr.length);
      } else {
        Toast.show({
          content: res.msg,
        });
      }
    } catch (error: any) {
      console.error(error);
    } finally {
      setIsLoading(false);
      Loading.hide();
    }
  };

  const goDetail = async (item) => {
    try {
      console.log("item===", item);
      let wxUrl = ""; // 小程序路径
      let appUrl = ""; // app路径
      let httpUrl = ""; // http路径
      let env = getClientEnv();
      switch (item.productType) {
        case "11": // 充电卡-除服务费折扣卡
        case "5": // 服务费折扣卡
          wxUrl = "/charging/pages/voucher-list/index?tabIndex=0";
          appUrl = "xiaopeng://charging/card?type=0";
          if (item.chargePackType == "07") {
            wxUrl = "/charging/pages/voucher-list/index?tabIndex=2";
            appUrl = "xiaopeng://charging/card?type=2";
          }
          break;
        case "1": // 充电券
        case "6": // 充电券包
          wxUrl = "/charging/pages/voucher-list/index?tabIndex=1";
          appUrl = "xiaopeng://charging/card?type=1";
          break;
        case "7": // 充电VIP
          httpUrl = window.origin + "/apps/charge-web/charge-vip.html";
          break;
        case "4": // 活动平台参与机会
          httpUrl = item.otherActivityUrl;
          break;
        case "12": // 渠道生活权益
          if (!item.productCaseId) {
            Toast.show({
              content: "奖品发放中，请稍后重试",
            });
          } else {
            // await getBenefit(item);
            httpUrl =
              window.origin +
              "/apps/charge-web/charge-vip.html#/exchange-rights?benefitInfoId=" +
              item.productCaseId;
          }
          break;
        case "8": // 积分
          wxUrl = "/charging/pages/voucher-list/index?tabIndex=3";
          appUrl = "xiaopeng://charging/card?type=3";
          break;
        case "14": //商城
          httpUrl =
            env == "product"
              ? "https://mall.xiaopeng.com/coupon/list"
              : "https://pmall.cs-pre.xiaopeng.com/coupon/list";
          appUrl = "xiaopeng://account/coupons?cate=ESHOP_COUPON";
          // httpUrl =
          //   window.origin +
          //   "/apps/charge-web/jump-to-wx-mini.html?page=charging/pages/voucher-list/index&query=tabIndex=1";
          break;
        default:
          break;
      }
      console.log("跳转的各个链接==", {
        wxUrl,
        appUrl,
        httpUrl,
      });
      const channel = getChannel();
      console.log("channel===", channel);
      if (["iosBrowser", "browser"].includes(channel) && appUrl) {
        // 在普通浏览器中
        const url = `https://app.xiaopeng.com/activity/openurl?url=${encodeURIComponent(appUrl)}`;
        window.location.href = url;
      } else {
        if (httpUrl) {
          // goToPage(httpUrl)
          if (
            httpUrl.includes(window.location.origin) ||
            item.productType == "4" ||
            item.productType == "14"
          ) {
            window.location.href = httpUrl;
          } else {
            goToPageV2({ url: httpUrl });
          }
        } else {
          goToNativePage({
            mini: wxUrl,
            app: appUrl,
          });
        }
        await new Promise((resolve) => setTimeout(resolve, 350));
      }
    } catch (error) {
      console.log(error);
    }
  };

  // 查询奖品信息
  const getBenefit = async (item) => {
    try {
      const res = await getBenefitInfo({ benefitInfoId: item.productCaseId });
      if (res.code === 200) {
        console.log(res.data);
        setCopyDialogInfo({ productName: item.productName, ...res.data });
        setCopyDialogVisible(() => true);
      } else {
        Toast.show({
          content: res.msg,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleCopy = () => {
    Toast.show({
      content: "已复制到剪贴板",
    });
  };

  const gotoDetial = useLockFn(async (item) => {
    await goDetail(item);
    await trackGdp("P20190", "B002", {
      trackName: "充电_营销奖品记录页_按钮点击",
      origin: getChannel(),
      userType: "",
      activityId: searchParams.get("activityCode"),
      prize_type: item.productType,
      prize_name: item.productName,
      prize_id: item.productCode,
    });
  });

  return (
    <PageContainer>
      <div
        className="luckyRecord"
        style={{ overflow: copyDialogVisible ? "hidden" : "auto" }}
        ref={contentRef}
      >
        {/* <NavBar title="中奖记录" /> */}
        <div
          className="content"
          onScroll={() => {
            console.log("scroll");
          }}
        >
          {recordList.map((item: any, index: number) => {
            return (
              <div className="card" key={index}>
                <div className="left">
                  <div className="title">{item.productName}</div>
                  <div className="time">{item.raffleTime}</div>
                </div>
                <div
                  className="right"
                  style={{ border: "1px solid #181916" }}
                  onClick={() => gotoDetial(item)}
                >
                  去看看
                </div>
              </div>
            );
          })}
          {recordList.length === 0 && (
            <div className="noData">
              <img src={processOssImage(img_empty)} />
              暂无奖品记录
            </div>
          )}
          {!hasMore && recordList.length > 0 && (
            <div className="endMessage">没有更多数据了</div>
          )}
        </div>

        {/* 复制弹窗 */}
        <Dialog
          visible={copyDialogVisible}
          onClose={() => setCopyDialogVisible(() => false)}
          getContainer={null}
          closeOnMaskClick={false}
          bodyClassName="customDialogBody"
          content={
            <>
              <div className="dialogContent">
                <div className="copyDialog">
                  <div className="cTitle">{copyDialogInfo.productName}</div>
                  <div className="p1">1.复制兑换链接至手机浏览器打开</div>
                  <div
                    className="copyBox"
                    style={{ border: "1px solid #181916" }}
                  >
                    <div className="code">
                      {copyDialogInfo.redeemLink || "-"}
                    </div>
                    <CopyToClipboard
                      text={copyDialogInfo.redeemLink}
                      onCopy={handleCopy}
                    >
                      <div className="btn">复制链接</div>
                    </CopyToClipboard>
                  </div>
                  <div className="p1">
                    2.复制卡号{copyDialogInfo.benefitType === 2 && <>、卡密</>}
                    前往兑换链接进行兑换
                  </div>
                  <div
                    className="copyBox"
                    style={{ border: "1px solid #181916" }}
                  >
                    <div className="code">{copyDialogInfo.cardNo || "-"}</div>
                    <CopyToClipboard
                      text={copyDialogInfo.cardNo}
                      onCopy={handleCopy}
                    >
                      <div className="btn">复制卡号</div>
                    </CopyToClipboard>
                    copyDialogInfo
                  </div>
                  {copyDialogInfo.benefitType === 2 && (
                    <div
                      className="copyBox"
                      style={{ border: "1px solid #181916" }}
                    >
                      <div className="code">
                        {copyDialogInfo.cardKey || "-"}
                      </div>
                      <CopyToClipboard
                        text={copyDialogInfo.cardKey}
                        onCopy={handleCopy}
                      >
                        <div className="btn">复制卡密</div>
                      </CopyToClipboard>
                    </div>
                  )}

                  <div className="p2">使用规则说明</div>
                  <div className="p3">{copyDialogInfo.ruleDesc}</div>
                </div>
                <div className="close_outer">
                  <img
                    className="icon_close"
                    src={processOssImage(icon_close)}
                    onClick={() => setCopyDialogVisible(false)}
                  />
                </div>
              </div>
            </>
          }
        ></Dialog>
      </div>
    </PageContainer>
  );
};

export default luckyRecord;
